<template>
	<div id="Recharge">
		<div class="Recharge_box">
			<div class="payment_box">
                <!-- <div class="payment_tit" style="color: #9AA2C9">充值系统升级中,请联系客服咨询,带来不便敬请谅解</div> -->
				<div class="payment_tit">请选择你要购买的支付数量</div>
				<div class="payment_list">
					<div class="payment_item" v-for="(item, index) in BeansArr" :key="index"
						:class="{ 'active': Idx == index }" @click="choose(item, index)">
						<!-- <div class="ceng"></div> -->
						<div class="title">金币充值</div>
						<div class="pic"></div>
						<div class="face"><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ item.bean }}</div>
						<span >≈￥{{ item.price }}</span>
					</div>
				</div>
			</div>
			

			<div class="pay_content">
				<div class="payment_btns">
					<p @click="PostRecharge_Code('6')"><img src="@/assets/images/public/zhifubao.png" alt="">支付宝</p>
					<p @click="Carmichael"><img src="@/assets/images/public/kami.png" alt="">卡密支付</p>
				</div>
				<div class="Ipt">
					<input type="text" placeholder="请输入卡密兑换码" v-model="card">
					<p @click="PostCard_recharge">卡密兑换</p>
				</div>
			</div>

			<div class="order_box">
				<!-- <div class="order_tit">
					充值记录
				</div> -->
				<div class="order_list">
					<div class="order_item">
						<div class="Gold" style="color: #9AA2C9">金币</div>
						<div class="Price" style="color: #9AA2C9">价格</div>
						<div class="Code" style="color: #9AA2C9">订单号</div>
						<div class="state" style="color: #9AA2C9">状态</div>
						<div class="btn"></div>
					</div>
					<div class="line"></div>
					<div class="order_item" v-for="(item, index) in RecordArr" :key="index">
						<div class="Gold" style="color: #E9B85A;">{{ item.bean }}</div>
						<div class="Price" style="color: #009FE8">{{ item.price }}</div>
						<div class="Code">{{ item.code }}</div>
						<div class="state" style="color: #5AE9D0">{{ item.status_alias }}</div>
						<div class="btn">
							<p @click="ToPaymentDetails(item)">查看</p>
						</div>
					</div>
				</div>

				<div class="PageNum">
					<el-pagination background layout="prev, pager, next" @current-change="change" :page-size="per_page"
						:total="total">
					</el-pagination>
				</div>
			</div>

			<van-overlay :show="Code_Show">
				<div class="wrapper">
					<div class="QR_code">
						<div class="QR_title" v-if="mk == '6'"><img src="@/assets/images/public/zhifubao.png" alt="">支付宝
						</div>
						<div class="QR_img">
							<img :src="Code_Img" alt="">
						</div>
						<div class="QR_btn" @click="Gb_Code_Show">支付完成</div>
					</div>
				</div>
			</van-overlay>

		</div>
	</div>
</template>

<script>
import {
	Beans,
	Recharge,
	Recharge_record,
	BeansFirst,
	BeansTotal,
	PersonalInfo,
	Card_recharge
} from '@/network/api.js'

import {
	mapState,
	mapMutations
} from 'vuex'
export default {
	name: 'Recharge',
	data() {
		return {
			BeansArr: [],
			Idx: 0,
			BeanId: '',
			card_link: '',
			card: '',

			RecordArr: [],
			total: 0,
			per_page: 0,
			pagenum: '1',
			Code_Img: null,
			Code_Show: false,
			mk: ''
		}
	},

	created() {
		this.GetBeans()
		this.GetRecharge_record()
	},

	methods: {
		GetBeans() {
			Beans().then((res) => {
				this.BeansArr = res.data.data
				this.BeanId = res.data.data[0].id
				this.card_link = res.data.data[0].card_link
			})
		},

		choose(item, index) {
			this.Idx = index
			this.BeanId = item.id
			this.card_link = item.card_link
		},

		PostRecharge_Code(v) {
			this.mk = v
			Recharge(this.BeanId, v).then((res) => {
				this.Code_Img = res.data.list.qr_url
				this.Code_Show = true;
                console.log(res);
                
                if (res.data.code == 200) {
                    
                } 
                else {
                    // this.$message({
                    //     message: res.data.message,
                    //     type: 'error'
                    // })
                }

			})

            
		},

		PostRecharge(type) {
			const newRoute = this.$router.resolve({
				path: '/Payment',
				query: {
					type: type,
					id: this.BeanId,
				}
			})
			window.open(newRoute.href, '_blank')
		},

		Gb_Code_Show() {
			this.Code_Show = false
		},

		Carmichael() {
			window.open(this.card_link, '_blank')
		},



		PostCard_recharge() {
			Card_recharge(this.card).then((res) => {
				this.$message({
					message: '兑换成功',
					type: 'success'
				})
			})
		},

		GetRecharge_record() {
			Recharge_record(this.pagenum).then((res) => {
				this.RecordArr = res.data.data.data
				this.total = res.data.data.total
				this.per_page = res.data.data.per_page
			})
		},

		change(v) {
			this.pagenum = v
			this.GetRecharge_record()
		},

		ToPaymentDetails(item) {
			this.$router.push({
				path: '/PaymentDetails',
				query: {
					code: item.code
				}
			})
		},

		...mapMutations([
			'User'
		])
	},

	computed: {
		...mapState([
			'user'
		])

	},

	watch: {

	}

}
</script>

<style lang="scss">
.Recharge_box {
	width: 100%;
	margin: 0 auto;
	padding-top: 20px;

	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;

		.QR_code {
			width: 360px;
			border: 1px solid #4854c9;
			background-color: #1e2355;
			border-radius: 4px;

			.QR_title {
				height: 50px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 24px;
				margin-top: 10px;

				img {
					width: 40px;
					margin-right: 5px;
				}
			}

			.QR_img {
				width: 205px;
				height: 205px;
				margin: 10px auto;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.QR_btn {
				width: 160px;
				height: 40px;
				border: 1px solid #ffd322;
				margin: 20px auto 30px;
				text-align: center;
				line-height: 40px;
				border-radius: 4px;
				font-size: 20px;
				color: #ffd322;
				cursor: pointer;
			}

		}
	}

	.payment_box {
		width: 100%;
		background: #0F111C;
		border-radius: 4px;
		overflow: hidden;
		padding: 20px 20px;
		box-sizing: border-box;

		.payment_tit {
			text-align: center;
			font-size: 20px;
			color: #fff;
			margin: 10px 0;
		}

		.payment_list {
			width: 100%;
			display: flex;
			justify-content: space-between;

			.payment_item {
				width: 210px;
				background: url(../../assets/images/Roll/LV1.png) no-repeat center;
				background-size: 100% 100%;
				border-radius: 4px;
				overflow: hidden;
				position: relative;
				border: 1px solid transparent;
				box-sizing: border-box;
				cursor: pointer;
				font-family: Oxanium;
				.ceng {
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: 100%;
					background: #E9B10E;
					opacity: 0;
				}

				.title {
					height: 32px;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #ffffff;
					background-image: linear-gradient(90deg, #6f5a39, #6f4c2c);
					background-blend-mode: normal, normal;
					border-radius: 1px;
					border: 1px solid #dcae64;
					user-select: none;
					margin-top: 10px;
					margin-left: 20px;
					margin-right: 20px;
				}

				.pic {
					width: 160px;
					height: 140px;
					margin: 10px auto;
					background: url(../../assets/images/PublicImg/JB1.png) no-repeat center;
					background-size: contain;
				}

				.face {
					width: 100%;
					height: 30px;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #ffd300;
					font-size: 22px;

					img {
						width: 28px;
						height: 28px;
						vertical-align: middle;
						margin-bottom: 2px;
					}
				}

				span {
					display: block;
					text-align: center;
					color: #ccc;
					font-size: 16px;
					margin-bottom: 10px;
				}

				&:nth-child(2) {
					.pic {
						background: url(../../assets/images/PublicImg/JB2.png) no-repeat center;
						background-size: contain;
					}
				}

				&:nth-child(3) {
					.pic {
						background: url(../../assets/images/PublicImg/JB3.png) no-repeat center;
						background-size: contain;
					}
				}

				&:nth-child(4) {
					.pic {
						background: url(../../assets/images/PublicImg/JB4.png) no-repeat center;
						background-size: contain;
					}
				}

				&:nth-child(5) {
					.pic {
						background: url(../../assets/images/PublicImg/JB5.png) no-repeat center;
						background-size: contain;
					}
				}

				&:nth-child(6) {
					.pic {
						background: url(../../assets/images/PublicImg/JB6.png) no-repeat center;
						background-size: contain;
					}
				}

				&.active {
					border-color: #E9B10E;

					.ceng {
						opacity: .1;
					}
				}
			}
		}

	}

	.pay_content {
		width: 100%;
		display: flex;
		align-items: center;

		.payment_btns {
			width: 480px;
			height: 60px;
			display: flex;

			p {
				width: 220px;
				height: 60px;
				text-align: center;
				line-height: 60px;
				background: #23252f;
				border-radius: 4px;
				margin: 0 10px;
				font-size: 22px;
				border: 1px solid transparent;
				position: relative;
				cursor: pointer;

				img {
					width: 30px;
					height: 30px;
					vertical-align: middle;
					margin-bottom: 2px;
					margin-right: 5px;
				}

				&:hover {
					border-color: #7a7a77;

					&::after {
						opacity: .1;
					}
				}
			}
		}

		.Ipt {
			width: 100%;
			height: 40px;
			position: relative;
			display: flex;

			input {
				width: 540px;
				height: 100%;
				border: 1px solid #312f2c;
				border-radius: 4px;
				padding-left: 10px;
				padding-right: 10px;
				box-sizing: border-box;

				&:focus {
					border-color: #4d4d4c;
				}
			}

			p {
				width: 150px;
				height: 40px;
				cursor: pointer;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #ffffff;
				background-image: linear-gradient(90deg, #6f5a39, #6f4c2c);
				background-blend-mode: normal, normal;
				border-radius: 4px;
				border: 1px solid #dcae64;
				user-select: none;
				margin-left: 10px;

				&:hover {
					background-image: linear-gradient(90deg, #6f5a39, #47321d);
				}

			}
		}
	}

	.order_box {
		width: 100%;
		background: #0F111C;
		border-radius: 4px;
		margin-top: 40px;
		overflow: hidden;
		box-sizing: border-box;
		font-family: Oxanium;
		.order_tit {
			width: 100%;
			height: 70px;
			background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0) 100%);
			line-height: 70px;
			font-size: 24px;
			font-weight: bold;
			padding-left: 20px;
			box-sizing: border-box;
		}

		.order_list {
			width: 100%;
			padding: 0 20px;
			box-sizing: border-box;

			.line {
				width: 100%;
				border-bottom: 1px solid hsla(0, 0%, 100%, .08);
			}

			.order_item {
				width: 100%;
				height: 60px;
				display: flex;
				align-items: center;
				font-size: 14px;
				margin: 10px 0;

				.Gold {
					width: 220px;
				}

				.Price {
					width: 250px;
				}

				.Code {
					width: 350px;
				}

				.state {
					width: 250px;
				}

				.btn {
					p {
						width: 80px;
						height: 30px;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #ffffff;
						background-image: linear-gradient(90deg, #6f5a39, #6f4c2c);
						background-blend-mode: normal, normal;
						border-radius: 4px;
						border: 1px solid #dcae64;
						user-select: none;
						margin-left: 10px;

						&:hover {
							background-image: linear-gradient(90deg, #6f5a39, #47321d);
						}
					}
				}

				&:first-child {
					font-size: 12px;
					background-color: #0F111C;
					height: 30px;
				}

				&:nth-child(2n) {
					background-image: linear-gradient(90deg, rgba(255, 162, 24, 0) 0%, rgba(93, 81, 136, 0.19) 52%, rgba(255, 162, 24, 0) 100%);
				}
			}
		}

		.PageNum {
			width: 100%;
			margin-left: 25px;
			margin-top: 20px;
			margin-bottom: 20px;

			li {
				background: #111111 !important;

				&.active {
					background: #4854c9 !important;
				}

				&:hover {
					color: #fff !important;
				}
			}

			.btn-prev,
			.btn-next {
				background: #111111;
			}
		}
	}
}</style>
